import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

export const schema = Joi.object().keys({
  phone: Joi.string().required(),
  new_password: Joi.string().required(),
  pin: Joi.string().required(),
  agent_id: Joi.number().integer().allow(''),
  email: Joi.string().required(),
});

export default function registerUser(userInfo) {

  let validateResult = Joi.validate(userInfo, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

  if(!userInfo){
    throw 'Missing userInfo'
  }

	return new Promise((resolve, reject) => {
		axios.put(APIAddress, {'uri': '/register_user/',
    'method': 'POST',
    'data': JSON.stringify(userInfo),
    'token': localStorage.getItem('token')})
		.then((res) => {
			resolve(res.data);
		})
		.catch((err) => {
			reject(err);
		})
	})
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/user/registerUser.js